/**
 * Component for displaying workflow progress steps
 */

import React from 'react';
import type { WorkflowStep } from '../types/breeding';

interface WorkflowProgressProps {
  steps: WorkflowStep[];
}

export function WorkflowProgress({ steps }: WorkflowProgressProps) {
  const getStepIcon = (status: WorkflowStep['status']) => {
    switch (status) {
      case 'completed':
        return '';
      case 'error':
        return '';
      default:
        return '�';
    }
  };

  return (
    <div className="progress-section">
      <div className="progress-card">
        <h2>Processing Breeding Workflow...</h2>
        <div className="progress-steps">
          {steps.map((step) => (
            <div key={step.id} className={`progress-step ${step.status}`}>
              <div className="progress-step-title">
                {getStepIcon(step.status)} {step.title}
              </div>
              <div className="progress-step-message">{step.message}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
